export const CUSTOM_FIELDS_FILTER_PARAM_KEY = 'customFieldsFilter';
